module.exports = __webpack_public_path__ + "static/media/google-play.0dde7dc4.png";